<template>
  <pg-modal ref="popup" class="pop-up-modal" :style="popupStyle">
    <iframe
      :src="surveyUrl"
      frameborder="0"
      height="100%"
      width="100%"
      :sandbox="sandboxPermissions"
      :allow="allowedPermissions"
    />

    <div
      class="pop-up__close"
      :style="popupCloseBtnStyle"
      @click="handlePopupClose"
    >
      <img src="../assets/close-button.svg" alt="Close" />
    </div>
  </pg-modal>
</template>

<script>
import Modal from "@/components/modal.vue";
import embedMixins from "@/components/mixins/embedMixins";

export default {
  // expose some function on webcomponent to outside world
  expose: ["handlePopupOpen", "handlePopupClose"],
  components: {
    "pg-modal": Modal,
  },
  mixins: [embedMixins],
  props: {
    id: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    preview: {
      type: Boolean,
      default: false,
    },
    exitIntent: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    btnStyle() {
      return {
        backgroundColor: this.buttonColor || "#00A3FF",
        color: this.buttonTextColor || "#fff",
        border: "none",
        borderRadius: "5px",
        padding: "10px 20px",
        cursor: "pointer",
      };
    },
    popupStyle() {
      return {
        width: this.width || "400px",
        height: this.height || "auto",
        padding: "2px",
        border: "none",
        borderRadius: "5px",
        overflow: "hidden",
      };
    },
    popupCloseBtnStyle() {
      return {
        borderRadius: "50%",
        cursor: "pointer",
        margin: "4px",
        padding: "4px",
        position: "absolute",
        right: "0",
        top: "0",
        transition: "background-color 85ms,color 85ms",
        zIndex: 2,
      };
    },
  },
  mounted() {
    if (this.exitIntent) {
      document.body.addEventListener("mouseleave", this.handlePopupOpen);
    }
  },
  methods: {
    handlePopupOpen() {
      this.$refs.popup.open();
      if (this.exitIntent) {
        this.removeExitIntentListener();
      }
      document.body.style.overflowY = "hidden";
    },
    handlePopupClose() {
      this.$refs.popup.close();
      document.body.style.overflowY = "auto";
    },
    removeExitIntentListener() {
      document.body.removeEventListener("mouseleave", this.handlePopupOpen);
    },
  },
};
</script>

<style scoped>
.pop-up__close svg:hover {
  fill: rgba(76, 102, 146, 0.88);
}
</style>
